import { normalizeInvoiceStatus } from "./invoiceStatusHelpers";

const QUICK_PAY_STATUSES = new Set([
  "awaiting_payment",
  "partial",
  "overdue",
  "approved",
]);

export function canQuickPayInvoice(invoice, resolveStatus) {
  if (!invoice || typeof resolveStatus !== "function") return false;

  const status = normalizeInvoiceStatus(resolveStatus(invoice));
  const due = Math.max(
    Number(invoice?.amount_due ?? invoice?.amountDue ?? 0),
    0,
  );

  if (due <= 0.009) return false;
  return QUICK_PAY_STATUSES.has(status);
}

export function resolveQuickPayFinanceInvoiceId(invoice = {}) {
  return (
    invoice?.finance_invoice_id ??
    invoice?.financeInvoiceId ??
    invoice?.id ??
    invoice?.invoice_id ??
    null
  );
}
